import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle: string;
  action?: React.ReactNode;
  isPrintView?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, action, isPrintView }) => {
  if (isPrintView) {
    return null;
  }

  return (
    <div className="pb-6 mb-8 border-b border-slate-200 flex flex-col sm:flex-row justify-between sm:items-start gap-4">
      <div>
          <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 mb-2">{title}</h2>
          <p className="text-base sm:text-lg text-slate-500">{subtitle}</p>
      </div>
      {action && <div className="flex-shrink-0 w-full sm:w-auto">{action}</div>}
    </div>
  );
};

export default PageHeader;